import React from 'react';
export function Footer() {
  return <div className="border-t border-gray-300 pt-8 space-y-6" data-id="element-171">
      <div className="text-sm text-gray-600 leading-relaxed space-y-4" data-id="element-172">
        <p className="font-semibold" data-id="element-173">Disclaimer:</p>
        <p data-id="element-174">
          These statements have not been evaluated by the Food and Drug
          Administration. This product is not intended to diagnose, treat, cure,
          or prevent any disease. Results may vary from person to person.
        </p>
        <p data-id="element-175">
          Individual results may vary, testimonials are not claimed to represent
          typical results. Results shown may not reflect the typical user's
          experience, and are not intended to represent or guarantee that anyone
          will achieve the same or similar results.
        </p>
      </div>
      <div className="flex flex-wrap gap-4 justify-center text-sm text-gray-600" data-id="element-176">
        <a href="https://cocunat.com/en-us/landings/about-us" className="hover:text-gray-900" data-id="element-177">
          About Us
        </a>
        <span className="text-gray-400" data-id="element-178">|</span>
        <a href="https://cocunat.com/en-us/landings/privacy-policy" className="hover:text-gray-900" data-id="element-179">
          Security, Privacy & Cookies
        </a>
      </div>
      <p className="text-xs text-gray-500 text-center" data-id="element-180">
        This website is an independent professional comparison and review site
        supported by referral fees from the sites and products featured.
      </p>
      <p className="text-xs text-gray-500 text-center" data-id="element-181">
        © 2025 All rights reserved.
      </p>
    </div>;
}